<template>
    <v-dialog
        @input="togglePopUp"
        v-model="showPopUp" 
        width="758" 
        height="566"
    >
        <v-card>
            <v-toolbar 
                height="40" 
                flat
            >
                <v-spacer></v-spacer>
                <v-btn 
                    icon 
                    @click.prevent="togglePopUp" 
                    :ripple="false"
                >
                    <v-icon color="black">
                        mdi-close
                    </v-icon>
                </v-btn>
            </v-toolbar>
            <v-container class="pt-5 pb-7">
                <div class="d-flex">
                    <!-- Left Navigation Drawer -->
                    <div 
                        v-if='isAProgram' 
                        class='left-navigation-drawer'
                    >
                        <v-row style="background-color: #F2F2F2;">
                            <v-col cols="12">
                                <div class="text-center py-3 ml-9">
                                    <h2 class="text-uppercase">
                                        {{ $t("habiteoStudio.program") }}
                                    </h2>
                                    <span>
                                        {{ $t("habiteoStudio.programAdress") }}
                                    </span>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row class="mx-3 mt-6">
                            <!-- Main Menu Buttons -->
                            <v-list class="pa-0">
                                <v-list-item 
                                    inactive 
                                    class="btn-holder text-center pa-0"
                                >
                                    <v-list-item-content class="pa-0">
                                        <div class="d-flex justify-space-around">
                                            <v-btn 
                                                text 
                                                class="habiteo-body-2 text-none separator"
                                            >
                                                <v-icon left>
                                                    icon-home
                                                </v-icon>
                                                {{ $t("sidebar.btnMainMenu") }}
                                            </v-btn>
                                            <v-btn 
                                                text 
                                                class="habiteo-body-2 text-none"
                                            >
                                                <v-icon left>
                                                    icon-return
                                                </v-icon>
                                                {{ $t("utils.previous") }}
                                            </v-btn>
                                        </div>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-row>
                        <v-divider class="mt-4" />
                        <v-row class="mx-3 mt-4">
                            <!-- Navigation Items -->
                            <v-row class="mx-3">
                                <v-list width="280">
                                    <v-list-item-group>
                                        <v-list-item 
                                            v-if="navigationItemsProgram" 
                                            v-for="item in navigationItemsProgram" :key="item.icon"
                                            :style='item.style ? item.style : ""'
                                            class='px-2'
                                        >
                                            <v-list-item-icon class="mr-4">
                                                <v-icon>
                                                    {{ item.icon }}
                                                </v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title v-text="item.label"></v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-row>
                        </v-row>
                    </div>
                    <div v-else>
                        <v-row style="background-color: #F2F2F2;">
                            <v-col cols="12">
                                <div class="text-center py-3 ml-9">
                                    <h2 class="text-uppercase">
                                        {{ $t("utils.plot") }}
                                    </h2>
                                </div>
                            </v-col>
                        </v-row>
                        <div class="pl-7 pt-5 pb-3">
                            <div class="pb-2">
                                {{ $t('utils.name') }} : BO12
                            </div>
                            <span style="font-size:small;">
                                <v-icon> mdi-share </v-icon>
                                {{ $t("share.share") }}
                            </span>
                        </div>
                            <v-divider class="my-2" />
                        <v-row class="mx-3 mt-4">
                            <!-- Navigation Items -->
                            <v-row class="mx-3">
                                <v-list width="280">
                                    <v-list-item-group>
                                        <v-list-item 
                                            v-if="navigationItemsPLot" 
                                            v-for="item in navigationItemsPLot" :key="item.icon"
                                            :style='item.style ? item.style : ""'
                                            class='px-2'
                                        >
                                            <v-list-item-icon class="mr-4">
                                                <v-icon>
                                                    {{ item.icon }}
                                                </v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title v-text="item.label"></v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-row>
                        </v-row>
                    </div>
                    <!-- Content Section -->
                    <div class="mx-5 pa-3 pl-5 content-importation-info">
                        <div>
                            <span class="font-weight-bold pb-4">
                                <v-icon class="mr-3">
                                    icon-lamp
                                </v-icon>
                                {{ $t("habiteoStudio.importInfo.title") }}
                            </span>
                        </div>
                        <span 
                            class="pa-0 habiteo-body-2" 
                            style="line-height: 20px;"
                        >
                            {{ isAProgram ? $t("habiteoStudio.importInfo.contentForProgram") : $t("habiteoStudio.importInfo.contentForPlot")}}
                        </span>
                    </div>
                </div>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'HelpImportationExemple',
        props: {
            showPopUp: {
                type: Boolean,
                required: true
            },
            isAProgram: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            navigationItemsProgram() {
                return [
                        { icon: 'icon-drone-view', label: this.$t('habiteoStudio.droneView') },
                        { icon: 'icon-general', label: this.$t('habiteoStudio.generalView') },
                        { icon: 'icon-aerial', label: this.$t('habiteoStudio.aerialView') },
                        { icon: 'icon-carousel', label: this.$t('habiteoStudio.caroussel'), style: 'border: green 4px solid;' },
                        { icon: 'icon-map-view', label: this.$t('habiteoStudio.mapView') }
                    ]
            },
            navigationItemsPLot() {
                return [
                        { icon: 'icon-threeD', label: this.$t('habiteoStudio.threeDPlan') },
                        { icon: 'icon-models', label: this.$t('habiteoStudio.virtualTour') },
                        { icon: 'icon-carousel', label: this.$t('habiteoStudio.plotCarrousel'), style: 'border: green 4px solid;' },
                    ]
            },
        },
        methods: {
            togglePopUp() {
                this.$emit('toggle-pop-up');
            }
        }
    };
</script>

<style lang="scss" scoped>
    .separator {
        &:first-child {
            border-right: 1px solid gray;
            border-radius: unset;
        }
    }
    .content-importation-info {
        height:100%; 
        width: 100%; 
        background-color: #E7F2F3; 
        border-radius: 6px;
    }
    .btn-holder {
        text-align: center;
    }
    .left-navigation-drawer {
        width: 330px;
        border-right: #F2F2F2 2px solid;
    }
</style>



// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/components/HelpImportationExemple.vue